(function () {
  if (window.__carlProductCardMedia) return;
  window.__carlProductCardMedia = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function cardMediaRoot(card) {
    return card ? card.querySelector('.card .media') : null;
  }

  function primaryEl(media) {
    return media ? media.querySelector('[data-card-primary-media]') : null;
  }

  function hoverEl(media) {
    return media ? media.querySelector('[data-card-hover-media]') : null;
  }

  function playVideo(el) {
    if (!el || el.tagName !== 'VIDEO' || reduceMotion.matches) return;
    var playPromise = el.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function pauseVideo(el) {
    if (!el || el.tagName !== 'VIDEO') return;
    el.pause();
    try {
      el.currentTime = 0;
    } catch (e) {}
  }

  function syncHoverState(card, hovering) {
    var media = cardMediaRoot(card);
    if (!media) return;
    var primary = primaryEl(media);
    var hover = hoverEl(media);

    if (hovering && hover) {
      pauseVideo(primary);
      playVideo(hover);
    } else {
      pauseVideo(hover);
      playVideo(primary);
    }
  }

  function onCardEnter(event) {
    var card = event.target.closest('.card-wrapper');
    if (!card) return;
    syncHoverState(card, true);
  }

  function onCardLeave(event) {
    var card = event.target.closest('.card-wrapper');
    if (!card) return;
    var related = event.relatedTarget;
    if (related && card.contains(related)) return;
    syncHoverState(card, false);
  }

  document.addEventListener('mouseenter', onCardEnter, true);
  document.addEventListener('mouseleave', onCardLeave, true);

  document.addEventListener('DOMContentLoaded', function () {
    if (reduceMotion.matches) return;
    document.querySelectorAll('.card-wrapper [data-card-primary-media][data-media-type="video"]').forEach(function (video) {
      playVideo(video);
    });
  });
})();
